import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";

// material-ui components
import { withStyles } from '@material-ui/core/styles';
import { Tab } from '@material-ui/core';
import { Tabs } from '@material-ui/core';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import navPillsStyle from 'assets/jss/material-kit-react/components/navPillsStyle';

class NavPills extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: props.active
        };
        this.handleChangeIndex = this.handleChangeIndex.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange = (event, active) => {
        this.setState({ active });
        if (this.props.onChange) {
            this.props.onChange(event, active);
        }
    };
    handleChangeIndex = index => {
        //  this.setState({ active: index });
    };
    render() {
        const {
            classes,
            tabs,
            direction,
            color,
            color_,
            horizontal,
            alignCenter
        } = this.props;
        const flexContainerClasses = classNames({
            [classes.flexContainer]: true,
            [classes.horizontalDisplay]: horizontal !== undefined
        });

        // const selectedColor = classes[color];
        // if(color_){
        //     selectedColor = color_;
        // }


        const tabButtons = (

            <Tabs
                classes={{
                    root: classes.root,
                    fixed: classes.fixed,
                    flexContainer: flexContainerClasses,
                    indicator: classes.displayNone
                }}
                value={this.state.active}
                onChange={this.handleChange}
                centered={alignCenter}
            >
                {tabs.map((prop, key) => {
                    var icon = {};
                    if (prop.tabIcon !== undefined) {
                        icon["icon"] = <prop.tabIcon className={classes.tabIcon} />;
                    }
                    const pillsClasses = classNames({
                        [classes.pills]: true,
                        [classes.horizontalPills]: horizontal !== undefined,
                        [classes.pillsWithIcons]: prop.tabIcon !== undefined
                    });
                    return (
                        <Tab
                            label={prop.tabButton}
                            key={key}
                            {...icon}
                            classes={{
                                root: pillsClasses,
                                labelContainer: classes.labelContainer,
                                label: classes.label,
                                selected: classes['primary'] //selected: classes[color]
                            }}
                            className={(this.state.active === key) ? classes['primary'] : ''}
                        //className={(this.state.active === key) ? classes[color] : ''}
                        />
                    );
                })}
            </Tabs>

        );
        const tabContent = (
            <div className={classes.contentWrapper}>
                <SwipeableViews
                    axis={direction === "rtl" ? "x-reverse" : "x"}
                    index={this.state.active}
                    onChangeIndex={this.handleChangeIndex}
                >
                    {tabs.map((prop, key) => {
                        return (
                            <div className={classes.tabContent} key={key}>
                                {prop.tabContent}
                            </div>
                        );
                    })}
                </SwipeableViews>
            </div>
        );
        return horizontal !== undefined ? (
            <GridContainer>
                <GridItem {...horizontal.tabsGrid}>{tabButtons}</GridItem>
                <GridItem {...horizontal.contentGrid}>{tabContent}</GridItem>
            </GridContainer>
        ) : (
                <div>

                    {tabButtons}
                    {tabContent}
                </div>
            );
    }
}

NavPills.defaultProps = {
    active: 0,
    color: "primary"
};

NavPills.propTypes = {
    classes: PropTypes.object.isRequired,
    // index of the default active pill
    active: PropTypes.number,
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            tabButton: PropTypes.string,
            tabIcon: PropTypes.func,
            tabContent: PropTypes.node
        })
    ).isRequired,
    color: PropTypes.oneOf([
        "primary",
        "warning",
        "danger",
        "success",
        "info",
        "rose",
        'purple',
    ]),
    direction: PropTypes.string,
    horizontal: PropTypes.shape({
        tabsGrid: PropTypes.object,
        contentGrid: PropTypes.object
    }),
    alignCenter: PropTypes.bool
};

export default withStyles(navPillsStyle)(NavPills);
